var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "div-main-list-page-table" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("span", { staticClass: "title" }, [_vm._v("Import Excel Log")]),
        _c(
          "el-button",
          {
            staticStyle: { "min-width": "100px" },
            attrs: { outline: "", size: "mini", round: "" },
            on: {
              click: function ($event) {
                _vm.$emit("close", (_vm.noAction = true))
              },
            },
          },
          [_vm._v(" Close ")]
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "table-block margin-top-0",
        style: {
          height: _vm.isFilterVisit
            ? "calc(100% - 150px)"
            : "calc(100% - 74px)",
        },
      },
      [
        _c(
          "el-table",
          {
            ref: "excelLogTable",
            attrs: {
              data: _vm.logData,
              height: "100%",
              border: true,
              "header-cell-style": _vm.HEADER_CELL_STYLE,
              "cell-style": _vm.CELL_STYLE,
              "empty-text": "No data found",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "createdAt",
                label: "Date Imported",
                width: "150",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            scope.row.createdAt
                              ? _vm.formatDateTime(
                                  new Date(scope.row.createdAt)
                                )
                              : "-"
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "updatedBy", label: "Updated By", width: "150" },
            }),
            _c("el-table-column", {
              attrs: { prop: "jobId", label: "Job Id", width: "200" },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "referenceNo",
                label: "Reference No.",
                width: "150",
              },
            }),
            _c("el-table-column", {
              attrs: { prop: "type", label: "Action", width: "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.type === "1"
                                ? "Insert"
                                : scope.row.type === "2"
                                ? "Insert"
                                : scope.row.type === "3"
                                ? "Update"
                                : scope.row.type === "4"
                                ? "Cancel"
                                : scope.row.type
                            ) +
                            " Job "
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "excjob", label: "Excel Job", width: "600" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "div-main-list-page-table-pagination" },
      [
        _c("el-pagination", {
          attrs: {
            background: "",
            "page-size": _vm.pageParam.pageSize,
            "page-sizes": [5, 10, 20, 50, 100],
            "current-page": _vm.pageParam.pageNumber,
            layout: _vm.paginationSetting,
            total: _vm.logTotal,
          },
          on: {
            "size-change": _vm.handleJobPageSizeChange,
            "current-change": _vm.handleJobPageChange,
            "update:pageSize": function ($event) {
              return _vm.$set(_vm.pageParam, "pageSize", $event)
            },
            "update:page-size": function ($event) {
              return _vm.$set(_vm.pageParam, "pageSize", $event)
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }